<template>
    <div>
        <p v-text="text"></p>
        <v-radio-group v-model="selected">
            <v-radio
                    v-for="choice in items[0].choices"
                    :key="choice.id"
                    :label="choice.label"
                    :value="choice.id"
            ></v-radio>
        </v-radio-group>
        <v-btn color="primary" :disabled="selected === null" @click="handleSubmitQuestion">Submit</v-btn>
    </div>
</template>
<script>
    export default {
        name: 'SingleQuestion',
        methods: {
            handleSubmitQuestion() {
                this.disable = true;
                this.$emit('evidenceDefined', {id: this.items[0].id, choice_id: this.selected});
            }
        },
        watch: {
            text() {
                this.selected = null;
                this.disable = false;
            }
        },
        props: ['text', 'items'],
        data: () => ({
            selected: null,
            disable: false,
        }),
    }
</script>